import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { toggle } from 'opticks';
import { ScoreRatingLarge } from '@daedalus/atlas/experimental/ScoreRatingLarge';
import { ScoreRating, ScoreRatingLoader } from '@daedalus/atlas/ScoreRating';
import { getReviewSentimentKey, reviewSentimentMessages } from '@daedalus/core/src/hotel/reviewSentiments';
import { toOneDecimalOrInteger } from '@daedalus/core/src/utils/number';
export { ScoreRatingLoader as ReviewRatingLoader };
interface Props {
  rating: number;
  totalRatingCount?: number;
  withIcon?: boolean;
  dataId?: string;
  underlineSubLabel?: boolean;
  hotelId?: string;
  variant?: 'compact' | 'large' | 'default';
}
const DEFAULT_DATA_ID = 'ReviewRating';
const LabelWrapper = /*#__PURE__*/styled('span')({
  name: "LabelWrapper",
  class: "l1lopy2s",
  propsAsIs: false
});
const getSubLabel = (totalRatingCount: Props['totalRatingCount'], variant: Props['variant'], formatMessage: IntlShape['formatMessage']) => {
  switch (variant) {
    case 'large':
      if (!totalRatingCount) {
        return formatMessage({
          id: 'reviews.basedOnNoReviews',
          defaultMessage: 'Based on verified reviews'
        });
      }
      return formatMessage({
        id: 'reviews.basedOnReviews',
        defaultMessage: '{reviewsCount, plural, one {Based on 1 verified review} other {Based on # verified reviews}}'
      }, {
        reviewsCount: totalRatingCount
      });
    case 'compact':
      if (!totalRatingCount) {
        return formatMessage({
          id: 'noReviews',
          defaultMessage: 'No reviews yet'
        });
      }
      return totalRatingCount?.toLocaleString();
    default:
      if (!totalRatingCount) {
        return formatMessage({
          id: 'noReviews',
          defaultMessage: 'No reviews yet'
        });
      }
      return formatMessage({
        id: 'reviewsCount',
        defaultMessage: '{reviews, plural, one {# review} other {# reviews}}'
      }, {
        reviews: totalRatingCount
      });
  }
};
export const ReviewRating = ({
  rating,
  totalRatingCount,
  underlineSubLabel = false,
  dataId = DEFAULT_DATA_ID,
  variant = 'default',
  hotelId
}: Props) => {
  const {
    formatMessage
  } = useIntl();
  const sentimentMessageKey = getReviewSentimentKey(rating);
  const translatedSentiment = sentimentMessageKey ? reviewSentimentMessages[sentimentMessageKey] : null;
  const isNoReviewsBSide = toggle('8783dc23-no-reviews', false, true);
  const formattedRating = toOneDecimalOrInteger(rating);
  if (formattedRating === null && !isNoReviewsBSide) {
    return null;
  }
  const subLabel = getSubLabel(totalRatingCount, variant, formatMessage);

  // Added as part of 9633c72c-guest-reviews-sort-filter
  if (variant === 'large') {
    return <div data-id={dataId}>
        <ScoreRatingLarge value={formattedRating ?? 0} label={translatedSentiment && formatMessage(translatedSentiment)} subLabel={subLabel && <LabelWrapper className={cx(underlineSubLabel && 'isUnderline')}>
                {subLabel}
              </LabelWrapper>} scoreId={hotelId && `HotelCardMobileScoreValue-${hotelId}`} scoreLabelId={hotelId && `HotelCardMobileScoreLabel-${hotelId}`} scoreSubLabelId={hotelId && `HotelCardMobileScoreSubLabel-${hotelId}`} />
      </div>;
  }
  return <div data-id={dataId}>
      <ScoreRating value={formattedRating ?? 0} label={translatedSentiment && formatMessage(translatedSentiment)} subLabel={subLabel && <LabelWrapper className={cx(underlineSubLabel && 'isUnderline')}>
              {subLabel}
            </LabelWrapper>} isCompact={variant === 'compact'} scoreId={hotelId && `HotelCardMobileScoreValue-${hotelId}`} scoreLabelId={hotelId && `HotelCardMobileScoreLabel-${hotelId}`} scoreSubLabelId={hotelId && `HotelCardMobileScoreSubLabel-${hotelId}`} />
    </div>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");